import { Firestore } from "../lib/firebase";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";



toast.configure({
  autoClose: 2000,
  draggable: false
});
const SELLING_PLATEFORMS_TABLE_NAME = "sellingPlatforms";


export function getSellingPlateform() {
  return Firestore.collection(SELLING_PLATEFORMS_TABLE_NAME)
    // .where("market", "==", country)
    .get()
    .then((results) => results.docs.map((garmentTypes) => garmentTypes.data()))
    .catch((error) => {
      throw new Error(error);
    });
}
export async function getSellingPlateformById(id) {
  try {
    return Firestore.collection(SELLING_PLATEFORMS_TABLE_NAME)
      .doc(id)
      .get()
      .then((docRef) => { return docRef.data() })
      .catch((error) => {
        throw new Error(error);
      })

  } catch (error) {
    throw error;
  }
}

export function deleteSellingPlateformById(id, setData, isDeleting, setIsDeleting) {

  if (isDeleting) {
    return;
  }

  setIsDeleting(true);

  const docRef = Firestore.collection(SELLING_PLATEFORMS_TABLE_NAME).doc(id);

  docRef.delete()
    .then(() => {
      setData(prevData => prevData.filter(item => item.id !== id));
      toast.success("Selling Plateform deleted successfully!", {
        position: toast.POSITION.TOP_LEFT
      });
    })
    .catch((error) => {
      console.error("Error removing document: ", error);
    })
    .finally(() => {
      setIsDeleting(false);
    });
}

export const create = async (payload, setData, inputText, setInputText, id, setIsLoading, isLoading) => {
  try {
    // Check if already loading or if an error has occurred
    if (isLoading) {
      return;
    }

    setIsLoading(true);

    // Check if the mint condition value already exists in Firestore
    const existingDoc = await Firestore.collection(SELLING_PLATEFORMS_TABLE_NAME)
      .where('value', '==', payload.value)
      .get()

    const loadingFunc = () => {
      setIsLoading(false)
    }
    if (!existingDoc.empty) {
      toast.error("Selling Plateform already exists", {
        position: toast.POSITION.TOP_LEFT
      });

      setTimeout(loadingFunc, 2000);
      return;
    }

    await Firestore.collection(SELLING_PLATEFORMS_TABLE_NAME)
      .doc(payload.id)
      .set(payload)
      .then(() => {
        setData(prevData => [...prevData, { id: id, value: inputText, label: inputText }]);
        setInputText("");
        toast.success("Selling Plateform created successfully!", {
          position: toast.POSITION.TOP_LEFT

        });
        setTimeout(loadingFunc, 2000);

      });
  } catch (error) {
    toast.error(error.message, { position: toast.POSITION.TOP_LEFT });
  }
};
export const update = async (payload, history) => {
  try {
    // Check if the garment value already exists in Firestore
    const existingDoc = await Firestore.collection(SELLING_PLATEFORMS_TABLE_NAME)
      .where('value', '==', payload.value)
      .get();

    if (!existingDoc.empty) {
      toast.error("Selling Plateform already exists", {
        position: toast.POSITION.TOP_LEFT
      });
      return;
    }

    await Firestore.collection(SELLING_PLATEFORMS_TABLE_NAME)
      .doc(payload.id)
      .set(payload)
      .then(() => {
        history.goBack()
        toast.success("Selling Plateform updated successfully!", {
          position: toast.POSITION.TOP_LEFT
        });
      });
  } catch (error) {
    toast.error(error.message, { position: toast.POSITION.TOP_LEFT });
  }
};



